'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('cross-fetch/polyfill');
var translationRegistryOpenapiClient = require('@bookingcom/translation-registry-openapi-client');

class TranslationRegistryConfig {
}
TranslationRegistryConfig.ENVOY_URL = 'http://127.0.0.1:9211';
TranslationRegistryConfig.AUTHX_AGENCT_URL = 'http://127.0.0.1:228';
TranslationRegistryConfig.SERVER_ROLE = 'b-localization-translation-registry';
TranslationRegistryConfig.SM_SVC_NAME = `${TranslationRegistryConfig.SERVER_ROLE}.service`;
TranslationRegistryConfig.DLB_PROD_URL = 'https://translation-registry.booking.com';
TranslationRegistryConfig.DQL_DQS_URL = 'https://translation-registry.dqs.booking.com';

exports.BookingEnv = void 0;
(function (BookingEnv) {
    BookingEnv["PROD"] = "prod";
    BookingEnv["DQS"] = "dqs";
})(exports.BookingEnv || (exports.BookingEnv = {}));

class BaseAPIError {
    constructor(message, stack) {
        this.message = message;
        this.stack = stack;
    }
}
// We should not subclass Error to make sure that the promise is rejected correctly
// https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/runtime.mustache#L212
class AuthxError extends BaseAPIError {
    constructor(stack) {
        super("Calling Authx for S2s token failed. Use DLB if you don't have access to Authx & Envoy", stack);
    }
}
class TranslationRegistryApiError extends BaseAPIError {
    constructor(stack) {
        super('Error calling Translation Registry API', stack);
    }
}

async function serviceMeshFetch(url, init) {
    const fetchUrl = replaceBasePath(url, TranslationRegistryConfig.ENVOY_URL);
    const s2sTokenResponse = await fetch(`${TranslationRegistryConfig.AUTHX_AGENCT_URL}/s2s_auth/issue_token/${TranslationRegistryConfig.SERVER_ROLE}`);
    if (!s2sTokenResponse.ok) {
        throw new AuthxError(await s2sTokenResponse.text());
    }
    const s2sToken = await s2sTokenResponse.text();
    const options = {
        method: init?.method,
        body: init?.body,
        headers: {
            ...init?.headers,
            'X-Booking-Authentication': s2sToken,
            Host: TranslationRegistryConfig.SM_SVC_NAME,
        },
    };
    const res = await fetch(fetchUrl, options);
    if (!res.ok) {
        throw new TranslationRegistryApiError(await res.text());
    }
    return res;
}
const dlbRetryProdFetch = dlbRetryFetchFactory(exports.BookingEnv.PROD);
const dlbRetryDQSFetch = dlbRetryFetchFactory(exports.BookingEnv.DQS);
function dlbRetryFetchFactory(env = exports.BookingEnv.PROD, timeoutMs = 5000, // responses can be 1MB
numRetries = 3) {
    return async function (url, init) {
        const retriesDefault = numRetries;
        // retry on codes 1xx, 429, 5xx
        const retryOnCode = /^(1\d\d)|(429)|(5\d\d)$/;
        const fetchUrl = env === exports.BookingEnv.PROD
            ? replaceBasePath(url, TranslationRegistryConfig.DLB_PROD_URL)
            : replaceBasePath(url, TranslationRegistryConfig.DQL_DQS_URL);
        let retries = retriesDefault;
        let response;
        let lastFetchError;
        const timeoutController = new AbortController();
        const abortTimer = setTimeout(() => timeoutController.abort(), timeoutMs);
        do {
            try {
                response = await fetch(fetchUrl, {
                    ...init,
                    // https://github.com/node-fetch/node-fetch/pull/747
                    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
                    signal: timeoutController.signal,
                });
                clearInterval(abortTimer);
                if (!retryOnCode.test(String(response.status))) {
                    return response;
                }
            }
            catch (err) {
                lastFetchError = err;
            }
            retries -= 1;
            await wait(100); // wait 100 ms
        } while (retries > 0);
        if (!response) {
            throw new TranslationRegistryApiError(`${lastFetchError.message}: ${lastFetchError.stack}`);
        }
        return response;
    };
}
async function wait(timeMs) {
    return new Promise(resolve => setTimeout(resolve, timeMs));
}
function replaceBasePath(ofThis, withThis) {
    const ofUrl = new URL(ofThis);
    const withUrl = new URL(withThis);
    ofUrl.protocol = withUrl.protocol;
    ofUrl.host = withUrl.host;
    ofUrl.port = withUrl.port;
    return ofUrl.toString();
}

class CopyExperimentsApi {
    constructor(bookingTopic, fetchApi = serviceMeshFetch) {
        this.api = new translationRegistryOpenapiClient.CopyExperimentsControllerApi(new translationRegistryOpenapiClient.Configuration({
            fetchApi,
            basePath: TranslationRegistryConfig.DLB_PROD_URL,
        }));
        this.bookingTopic = bookingTopic;
    }
    register(payload) {
        const request = {
            xBookingTopic: this.bookingTopic,
            copyExperimentRegisterPayload: payload,
        };
        return this.api.register(request);
    }
}

Object.defineProperty(exports, 'CopyExperimentPayloadFromJSON', {
  enumerable: true,
  get: function () { return translationRegistryOpenapiClient.CopyExperimentPayloadFromJSON; }
});
Object.defineProperty(exports, 'CopyExperimentPayloadToJSON', {
  enumerable: true,
  get: function () { return translationRegistryOpenapiClient.CopyExperimentPayloadToJSON; }
});
Object.defineProperty(exports, 'CopyExperimentSettingsLanguagesEnum', {
  enumerable: true,
  get: function () { return translationRegistryOpenapiClient.CopyExperimentSettingsLanguagesEnum; }
});
exports.AuthxError = AuthxError;
exports.BaseAPIError = BaseAPIError;
exports.CopyExperimentsApi = CopyExperimentsApi;
exports.TranslationRegistryApiError = TranslationRegistryApiError;
exports.TranslationRegistryConfig = TranslationRegistryConfig;
exports.dlbRetryDQSFetch = dlbRetryDQSFetch;
exports.dlbRetryFetchFactory = dlbRetryFetchFactory;
exports.dlbRetryProdFetch = dlbRetryProdFetch;
exports.serviceMeshFetch = serviceMeshFetch;
